import React, { useState } from "react";
import { useSite } from "../context/SiteContext";
import useReveal from "../hooks/useReveal";
import { useToast } from "../hooks/use-toast";

export default function Gathering({ onPledge }) {
  useReveal();
  const { toast } = useToast();
  const { c } = useSite();
  const { gathering, brand, ui } = c;
  const [nm, setNm] = useState("");
  const [place, setPlace] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const clean = nm.trim();
    if (!clean) {
      toast({ title: ui.needName, description: ui.needNameDesc });
      return;
    }
    onPledge({ name: clean, place: place.trim() });
    toast({
      title: ui.welcomeTitle,
      description: `${clean} ${ui.addedSuffix} Per silvam per saecula.`,
    });
    setNm("");
    setPlace("");
    document.getElementById("kindred")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="gathering" className="bg-ink2 py-28 sm:py-40 grain relative">
      <div className="max-w-2xl mx-auto px-5 sm:px-8 text-center">
        <div className="flex items-center justify-center gap-4 mb-7">
          <span className="eyebrow">{gathering.label}</span>
        </div>
        <h2 className="font-display text-5xl sm:text-7xl font-light text-parchment">{gathering.title}</h2>
        <p className="mt-6 text-xl leading-relaxed text-parchment/65 font-light">{gathering.text}</p>
        <p className="font-display italic text-2xl text-gold mt-6">{brand.motto}</p>

        <form onSubmit={submit} className="mt-11 flex flex-col gap-4 text-left">
          <input
            value={nm}
            onChange={(e) => setNm(e.target.value)}
            placeholder={ui.yourName}
            className="bg-transparent border-b border-parchment/30 focus:border-gold outline-none py-4 text-2xl font-display text-parchment placeholder:text-parchment/35 transition-colors"
          />
          <input
            value={place}
            onChange={(e) => setPlace(e.target.value)}
            placeholder={ui.yourPlace}
            className="bg-transparent border-b border-parchment/30 focus:border-gold outline-none py-4 text-2xl font-display text-parchment placeholder:text-parchment/35 transition-colors"
          />
          <button
            type="submit"
            className="mt-6 self-start font-label text-[0.72rem] uppercase tracking-[0.22em] text-ink bg-gold px-9 py-4 hover:opacity-90 transition-opacity duration-300"
          >
            {gathering.cta}
          </button>
        </form>
      </div>
    </section>
  );
}
